module.exports = __webpack_public_path__ + "static/media/trio v shot 2-mobile.b2eab36b.webp";